export const ADD_FEED = "ADD_FEED"
export const REMOVE_FEED = "REMOVE_FEED"
export const SET_ENTRIES = "SET_ENTRIES"
export const SET_FEEDS = "SET_FEEDS"
export const SET_LOADING = "SET_LOADING"
export const SET_PRIMARY = "SET_PRIMARY"
export const SET_QUERY = "SET_QUERY"
export const SET_SELECT = "SET_SELECT"
